import dayjs from 'dayjs'

// eslint-disable-next-line import/prefer-default-export
export function displayTimeStr(timeStr: string): string {
  return dayjs(timeStr).format('YYYY-MM-DD HH:mm:ss.SSS')
}
